import { ApiError } from '@api/client'
import { useI18n } from '@i18n/I18nProvider'
import { BottomSheet } from '@ui/BottomSheet'
import { ErrorState, LoadingState } from '@ui/States'
import { TreeDetails } from './TreeDetails'
import { useTree } from './useTree'

// La ficha completa de un árbol en una hoja, encima del mapa: no se sale del mapa, y desde ella la
// especie se abre en otra hoja encima. Cerrarla (o "atrás") vuelve a la tarjeta del árbol.
export const TreeSheet = ({ code, onClose }: { code: string; onClose: () => void }) => {
	const { t } = useI18n()
	const { data: tree, error, isPending, refetch } = useTree(code)
	const title = tree?.species?.commonName ?? t('tree.code', { code })
	return (
		<BottomSheet title={title} onClose={onClose}>
			{isPending ? (
				<LoadingState shape="detail" />
			) : error instanceof ApiError && error.isNotFound ? (
				<p role="alert" className="py-6 text-center text-lg">
					{t('tree.notFound')}
				</p>
			) : error || !tree ? (
				<ErrorState error={error} onRetry={() => refetch()} />
			) : (
				<TreeDetails tree={tree} channel="map" showName={false} withReport={false} />
			)}
		</BottomSheet>
	)
}
